import React, { useState, ReactNode } from 'react';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';

import { isPresent } from '../../../util/typeUtils';
import {
  OfferDataTable,
  OfferDataTableRow,
} from '../../DataTable/OfferDataTable';

interface ExpandableDataRowProps {
  label: ReactNode;
  sublabel?: ReactNode;
  value: ReactNode;
  dataRows: OfferDataTableRow[];
}
export function ExpandableDataRow({
  label,
  sublabel,
  value,
  dataRows,
}: ExpandableDataRowProps) {
  const [expanded, setExpanded] = useState(false);

  const primaryLabel = (
    <div>
      <a
        className="expandable-row-label"
        href="#"
        onClick={e => {
          e.preventDefault();
          setExpanded(!expanded);
        }}
      >
        <span>{label}</span>
        {expanded ? <MdExpandLess size={20} /> : <MdExpandMore size={20} />}
      </a>
      {sublabel && <div>{sublabel}</div>}
    </div>
  );

  let error: string | undefined;
  if (dataRows.some(row => row.error)) {
    error = dataRows
      .filter(row => row.error)
      .map(row => row.error)
      .join('; ');
  }

  const rows: OfferDataTableRow[] = [
    {
      label: primaryLabel,
      value: <div className="offer-value-container">{value}</div>,
      error,
    },
  ];
  if (expanded) {
    rows.push(...dataRows);
  }

  return (
    <div className={`expandable-row ${expanded ? 'expanded' : ''}`}>
      <OfferDataTable rows={rows.filter(isPresent)} />
    </div>
  );
}
